import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import { ProductGroupSetPageName, baseURLGetProductGroup } from "../Services/client";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import pageNameDefault from "./NameDefault/pageNameDefault";

export default function EditGroupPage() {
  const [productGroup, setProductGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const { groupID } = useParams();
  const location = useLocation();
  const [loadingStates, setLoadingStates] = useState({});
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname.split("").slice(14, 16).join("")
  );
  const { t, i18n } = useTranslation();
  const [selectedPageNames, setSelectedPageNames] = useState({});
  const isRTL = i18n.language === "fa";
  const labelClassName = isRTL ? "group-page-label-fa" : "group-page-label";
  const buttonClassName = isRTL ? "groupPage-button-fa" : "groupPage-button";

  useEffect(() => {
    setPageLanguage(location.pathname.split("").slice(14, 16).join(""));
  }, [location.pathname]);

  useEffect(() => {
    const fetchProductGroup = () => {
      setLoading(true);
      axios
        .get(baseURLGetProductGroup)
        .then((response) => {
          const initialSelectedNames = {};
          response.data.forEach((group) => {
            if (group.PageName) {
              const selectedItem = pageNameDefault.find((item) => item.name === group.PageName);
              if (selectedItem) {
                initialSelectedNames[group.ProductGroupId] = selectedItem.id.toString();
              }
            }
          });
          setSelectedPageNames(initialSelectedNames);
          const group = response.data.find((group) => group.ProductGroupId === groupID);
          setProductGroup(group);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching product group:", error);
          setLoading(false);
        });
    };

    fetchProductGroup();
  }, [groupID]);

  const handleUpdate = (group) => {
    const selectedId = selectedPageNames[group.ProductGroupId];
    const selectedItem = pageNameDefault.find((item) => item.id === Number(selectedId));

    if (selectedItem) {
      setLoadingStates((prev) => ({ ...prev, [group.ProductGroupId]: true }));

      axios
        .get(
          `${ProductGroupSetPageName}?groupId=${group.ProductGroupId}&pageName=${selectedItem.name}`
        )
        .then((response) => {
          setTimeout(() => {
            setLoadingStates((prev) => ({ ...prev, [group.ProductGroupId]: false }));
          }, 3000);
        })
        .catch((error) => {
          setLoadingStates((prev) => ({ ...prev, [group.ProductGroupId]: false }));
        });
    }
  };

  if (loading) {
    return <div></div>;
  }

  if (!productGroup) {
    return <div>Product group not found</div>;
  }

  return (
    <div className="groupPage-box">
      <div className="groupPage-box-content">
        {pageLanguage === "en" && (
          <div className="group-page-input-container">
            <label htmlFor="name" className={labelClassName}>
              {t("groupPage_en_name")}
            </label>
            <input
              type="text"
              value={productGroup.ProductGroupENName || ""}
              className="group-page-input group-page-input2"
              readOnly
            />
          </div>
        )}
        {pageLanguage === "fa" && (
          <div className="group-page-input-container">
            <label htmlFor="name" className={labelClassName}>
              {t("groupPage_fa_name")}
            </label>
            <input
              type="text"
              value={productGroup.ProductGroupName || ""}
              className="group-page-input group-page-input2"
              readOnly
            />
          </div>
        )}
       
      </div>
      <div className="groupPage-box-content">
      <div className="group-page-input-container">
          <label htmlFor="name" className={labelClassName}>
            {t("groupPage_page_name")}
          </label>
          <select
            className="group-page-input"
            value={selectedPageNames[productGroup.ProductGroupId] || "Select Page Name"}
            onChange={(e) =>
              setSelectedPageNames({
                ...selectedPageNames,
                [productGroup.ProductGroupId]: e.target.value,
              })
            }
          >
            <option value="Select Page Name">{t("groupPage_select_group")}</option>
            {pageNameDefault.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="groupPage-box-content">
        <div className="group-page-input-container">
          <label htmlFor="name" className={labelClassName}>
            {t("groupPage_product_group_id")}
          </label>
          <input
            type="text"
            value={productGroup.ProductGroupId || ""}
            className="group-page-input group-page-input2"
            readOnly
          />
        </div>
      </div>

      <div className="groupPage-box-content">
        <button
          onClick={() => handleUpdate(productGroup)}
          className={buttonClassName}
          disabled={loadingStates[productGroup.ProductGroupId]}
        >
          {loadingStates[productGroup.ProductGroupId] ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{ marginRight: "8px", color: "gray" }}
              />
              {t("groupPage_updating")}
            </>
          ) : (
            t("groupPage_update")
          )}
        </button>
      </div>
    </div>
  );
}
